webpackJsonp([136687819652038],{

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(8);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPage = function BlogPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container' },
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'blog',
	        style: { margin: '0 auto', maxWidth: '70ch', marginBottom: '5em' }
	      },
	      _react2.default.createElement(
	        _Link2.default,
	        { href: '/blog/20-march' },
	        '\u2190 Previous'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Don\u2019t stockpile your prayers'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'author' },
	        'by Jon Shulver, 25 March 2020'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'In Jesus\u2019 model prayer to \u201COur Father in Heaven\u201D he says these words: \u201CGive us today our daily bread.\u201D'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'They are familiar words to many. Just look at them for a moment though. Have you considered the strong emphasis on today? \u201CGive us today our daily bread\u201D It\u2019s not \u201CGive us today what we need for the coming week or month.\u201D It\u2019s not asking in advance \u2013 so we\u2019ve no need to come back to \u201COur Father in Heaven\u201D tomorrow. No, it\u2019s a daily request for our Father to meet our needs for today. We aren\u2019t to stockpile our prayer requests. We are to pray daily, for our daily needs.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Right now it will be for our good if we put that into practice. It\u2019s so easy to worry about tomorrow, next week, the next twelve weeks, the year and the future. But Jesus calls us to trust God with today. That doesn\u2019t mean we are never to plan or make preparations. It doesn\u2019t mean as Christians we\u2019re not to long for the amazing future when we will be with Jesus and everything will be made right. But we need not worry about tomorrow. Jesus tells us plainly in Matthew 7:34',
	        _react2.default.createElement(
	          'i',
	          null,
	          '\u201CTherefore do not worry about tomorrow, for tomorrow will worry about itself.\u201D'
	        ),
	        '\xA0Let\u2019s be honest, much of our worry and anxiety is about tomorrow not today, it\u2019s about the future not the present. As the pastor Kevin DeYoung says \u201CAnxiety is living out the future before it gets here.\u201D'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Can I encourage you to bring your daily needs to your Father in Heaven? To trust that his provision and grace will be sufficient for today. Let\u2019s not play out scenarios in our minds about tomorrow, we can come back to our Father tomorrow with tomorrow\u2019s concerns. Let\u2019s live, as best we can, one day at a time.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'And here\u2019s the good news. Each day as we come to our Heavenly Father, his love and faithfulness are new and fresh. They are never changing. We haven\u2019t got to seek his love today fearing that his love may have run out in the future, that tomorrow he won\u2019t have mercy on us. As the writer of Lamentations says',
	        _react2.default.createElement(
	          'i',
	          null,
	          '\u201CThe steadfast love of the Lord never ceases; his mercies never come to an end; they are new every morning; great is your faithfulness. The Lord is my portion, says my soul, therefore I will hope in him.\u201D'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Trust your Heavenly Father with today.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'And tomorrow, you can confidently do the same'
	      )
	    )
	  );
	};
	
	exports.default = BlogPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-25-march-js-a30a2e4ed7eff480f4e7.js